import React from 'react';
import { CheckCircle2, Award, Users, Phone } from 'lucide-react';
import { aboutText, companyData } from '../../data/mock';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Fachliche Kompetenz',
      text: 'Regelmäßige Fort- und Weiterbildungen'
    },
    {
      icon: Users,
      title: 'Persönliche Betreuung',
      text: 'Überschaubare Firmengröße, direkter Kontakt'
    },
    {
      icon: Phone,
      title: 'Direkte Erreichbarkeit',
      text: 'Jederzeit per Telefon erreichbar'
    }
  ];

  // Team/Office images from the company
  const teamImages = [
    {
      src: 'https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/olamdt4g_Anni%20B%C3%BCro%202.jpg',
      alt: 'Unser Team bei der Arbeit'
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/eonan627_Anni.JPG',
      alt: 'Besprechungsraum'
    }
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={teamImages[0].src}
                alt={teamImages[0].alt}
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-100 rounded-2xl -z-0" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-teal-600/10 rounded-full -z-0" />
            
            {/* Experience Badge */}
            <div className="absolute bottom-8 left-8 bg-white rounded-xl shadow-lg p-4 z-20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-teal-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-900">25+</p>
                  <p className="text-sm text-slate-600">Jahre Erfahrung</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Über uns
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Ihre zuverlässige Hausverwaltung seit über 20 Jahren
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              {aboutText}
            </p>

            {/* Feature List */}
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-5 h-5 text-teal-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900">{feature.title}</h3>
                    <p className="text-sm text-slate-600">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team Gallery */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Unser Team
            </span>
            <h3 className="text-2xl lg:text-3xl font-bold text-slate-900">
              Kompetent und engagiert für Sie da
            </h3>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/olamdt4g_Anni%20B%C3%BCro%202.jpg"
                alt="Büro Team"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/eonan627_Anni.JPG"
                alt="Besprechungsraum"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/l47xdmhq_Kahnstra%C3%9Fe%201%20B%C3%BCro%202.JPG"
                alt="Büro Mitarbeiter"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_admin-hausverwaltung/artifacts/ygpawuwn_Kahnstra%C3%9Fe%201%20B%C3%BCro.JPG"
                alt="Büro Mitarbeiterin"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
